import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "../lib/api";

const BrandingCtx = createContext(null);
export const useBranding = () => useContext(BrandingCtx);

export const PRESETS = {
  auro: { label: "Auro Amber", sidebar: "#0f172a", brand: "#d97706", brandHover: "#b45309", header: "#0f172a" },
  blue: { label: "Auro Blue", sidebar: "#0f172a", brand: "#2563eb", brandHover: "#1d4ed8", header: "#0f172a" },
  dark: { label: "Auro Dark", sidebar: "#111827", brand: "#f59e0b", brandHover: "#d97706", header: "#111827" },
  professional: { label: "Professional", sidebar: "#1e293b", brand: "#0ea5e9", brandHover: "#0284c7", header: "#1e293b" },
  industrial: { label: "Industrial", sidebar: "#292524", brand: "#ea580c", brandHover: "#c2410c", header: "#292524" },
};

export function applyTheme(t) {
  if (!t) return;
  const r = document.documentElement.style;
  r.setProperty("--sidebar", t.sidebar || "#0f172a");
  r.setProperty("--brand", t.brand || "#d97706");
  r.setProperty("--brand-hover", t.brandHover || "#b45309");
  r.setProperty("--header", t.header || t.sidebar || "#0f172a");
}

const POLL_INTERVAL_MS = 10000;

export function BrandingProvider({ children }) {
  const [branding, setBranding] = useState({ companyName: "Aurombica Engineering. Co. Pvt. Ltd.", shortName: "", caNumber: "C.A No-003", logo: "", favicon: "" });

  const load = useCallback(async () => {
    try {
      const { data } = await api.get("/branding");
      setBranding((prev) => (JSON.stringify(prev) === JSON.stringify(data) ? prev : data));
      applyTheme(data.theme);
      if (data.companyName) document.title = data.shortName || data.companyName;
      if (data.favicon) {
        let link = document.querySelector("link[rel~='icon']");
        if (!link) { link = document.createElement("link"); link.rel = "icon"; document.head.appendChild(link); }
        link.href = data.favicon;
      }
    } catch { /* ignore */ }
  }, []);

  useEffect(() => { load(); }, [load]);

  useEffect(() => {
    const t = setInterval(() => { if (!document.hidden) load(); }, POLL_INTERVAL_MS);
    const onVisible = () => { if (!document.hidden) load(); };
    document.addEventListener("visibilitychange", onVisible);
    return () => { clearInterval(t); document.removeEventListener("visibilitychange", onVisible); };
  }, [load]);

  return <BrandingCtx.Provider value={{ branding, refreshBranding: load }}>{children}</BrandingCtx.Provider>;
}
